/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A tool definition in the MCP export
 */
export type McpExportTool = {
  /**
   * Description of what the tool does
   */
  description: string;
  /**
   * JSON Schema for the tool's input parameters
   */
  inputSchema: any;
  /**
   * The tool name
   */
  name: string;
};

/** @internal */
export const McpExportTool$inboundSchema: z.ZodMiniType<
  McpExportTool,
  unknown
> = z.pipe(
  z.object({
    description: z.string(),
    input_schema: z.any(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "input_schema": "inputSchema",
    });
  }),
);

export function mcpExportToolFromJSON(
  jsonString: string,
): SafeParseResult<McpExportTool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpExportTool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpExportTool' from JSON`,
  );
}
